module.exports = __webpack_public_path__ + "img/plan.51c67396.png";